"use client";

import React, { Suspense } from "react";
import { useSearchParams } from "next/navigation";
import QuoteForm from "./QuoteForm";

function QuoteFormWithParams() {
  const searchParams = useSearchParams();
  const title = searchParams.get("title") || undefined;
  return <QuoteForm subject={title} />;
}

export default function QuotePageClient() {
  return (
    <Suspense fallback={<div style={{ padding: "3rem", textAlign: "center", color: "var(--text-muted)" }}>Loading form...</div>}>
      <QuoteFormWithParams />
    </Suspense>
  );
}
